//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "vux";
import { mapState } from "vuex";
import { service, nativeApi } from "@/common/index";
import { fetch } from "@/page/index";
import SrmCommonUtils from "@/utils/SrmCommonUtils"
import Vue from 'vue';
import { Overlay, Divider, Notify, Dialog, Toast,  RadioGroup, Radio } from 'vant';

Vue.use(Toast);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Overlay);

export default {
  name: "SelectionModal",
  components: {

  },
  props: {
    selectionConfig: {
      type: Object,
      default: {}
    },
    type: {
      type: String, /**checkbox, radio*/
      default: "radio"
    },
  },
  data() {
    return {
      searchValue: null,
      pageData: [],
      showSelectionModal: false,
      selectIndex: null,
      /** 刷新用变量 */
      pageIndex: 1,
      pageRows: 10,
      rowCount: 0,
      isLoading: true,
      listFinished: false,
      listLoading: false,
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo,
      languageCode: (state) => state.user.languageCode,
      dicCodes: (state) => state.user.dicCodes,
    }),
  },
  created() {

  },
  activated: function () {},
  mounted() {
    this.pageIndex = 1
    this.pageData = []
  },
  methods: {
    open(obj) {
      this.pageIndex = 1
      this.pageData = []
      this.showSelectionModal = true
      this.listPage()
    },
    cancel() {
      this.showSelectionModal = false
    },
    clean() {
      this.showSelectionModal = false
      this.$emit("on-change", {})
    },
    selectionOk() {
      let _selectData;
      if (this.type === 'radio') {
        if (this.selectIndex === null) {
          Toast('请选择数据后进行确认');
          return
        }
        _selectData = this.pageData[this.selectIndex]
      } else if (this.type === 'checkbox') {
        _selectData = []
        for (let i = 0; i < this.pageData.length; i++) {
          if (this.pageData[i].checked) {
            _selectData.push(this.pageData[i])
          }
        }
        if (_selectData.length === 0) {
          Toast('请选择数据后进行确认');
          return
        }
      }
      this.showSelectionModal = false
      this.$emit("on-change", _selectData)
    },
    selectedClick(rowData, rowIndex) {
      if (this.type === "radio") {
        this.selectIndex = rowIndex
      } else if (this.type === 'checkbox') {
        let _rowSelected = this.pageData[rowIndex].checked = undefined ? false : this.pageData[rowIndex].checked
        if (!!!_rowSelected) {
          for (let i = 0; i < this.pageData.length; i++) {
            if (i === rowIndex) {
              continue;
            }
            this.$set(this.pageData[i], "checked", false)
          }
        }
        this.$set(this.pageData[rowIndex], "checked", !!!_rowSelected)
        this.$set(rowData, "checked", !!!_rowSelected)
      }
    },
    listPage(params) {
      if (!!!this.selectionConfig.findApi) {
        throw new Error("未配置查询API")
        return
      }
      let _params = {
        pageIndex: this.pageIndex,
        pageRows: this.pageRows,
        lan: this.languageCode,
        attribute5: "MOBILE"
      }
      if (!!params) {
        _params = {
          ..._params,
          ...params
        }
      }
      if (!!this.selectionConfig.searchParams) {
        for (let key in this.selectionConfig.searchParams) {
          _params[key] = this.selectionConfig.searchParams[key]
        }
      }
      const _setData = (data) => {
        this.pageData = [
          ...this.pageData,
          ...data
        ]
        this.selectIndex = null;
        /*for (let i = 0; i < this.pageData.length; i++) {
          this.pageData[i].checked = false
        }*/
      }
      fetch[this.selectionConfig.findApi](_params).then((res) => {
        if (!!res.data && res.data.length > 0) {
          if (res.page.curIndex !== res.page.nextIndex) {
            this.pageIndex = res.page.nextIndex
          }
          this.rowCount = res.page.curIndex
          // 判断当前数据总数与后台数据总数是否相同来判断是否已添加上最后一页数据
          if (res.page.curIndex === res.page.pagesCount) {
            this.listFinished = true
          }
          if (res.page.curIndex === 1) {
            this.pageData = []
          }
          _setData(res.data)
        } else {
          this.pageData = []
          this.listFinished = true
        }
        this.listLoading = false
        this.isLoading = false
      });
    },
    listOnLoad() {
      this.listPage()
    },
    onRefresh () {
      // 状态设置
      if (this.listFinished) {
        this.isLoading = false
        return
      }
      this.listFinished = false
      this.listLoading = true
      this.isLoading = true
      this.listPage()
    },
    /**查看到货验收单详情*/
    viewBlacklistManageDetail(detail) {

    },
    selectModalOnSearch(val) {
      let _params = {}
      _params[this.selectionConfig.search.key] = val
      this.pageIndex = 1
      this.listPage(_params)
    },

    /**取快码信息*/
    getLookupValuesMeaning(lookupType, lookupValue) {
      const _this = this
      return new SrmCommonUtils(_this).getLookupMeaning(lookupType, lookupValue)
    },
    /**格式化数字*/
    getFormatNumberValue(val) {
      return new SrmCommonUtils(this).getFormatNumberValue(val)
    },
  },
  watch: {},
};



// WEBPACK FOOTER //
// ./src/page/components/SelectionModal.vue